<template>
  <div class="rg-playback-functions h-full">
    <tooltip
      tooltip-text="表示エリア指定"
      class="rg-playback-function-button"
      @click="onClickAreaSetting"
    >
      <area-setting-icon></area-setting-icon>
    </tooltip>
    <tooltip
      tooltip-text="日時設定"
      class="rg-playback-function-button"
      @click="onClickDateTimeSetting"
    >
      <date-time-setting-icon></date-time-setting-icon>
    </tooltip>
    <tooltip
      tooltip-text="URLをコピー"
      class="rg-playback-function-button"
      @click="onClickCopy"
    >
      <copy-icon></copy-icon>
    </tooltip>
  </div>
</template>

<script>
import AreaSettingIcon from "./AreaSettingIcon.vue";
import DateTimeSettingIcon from "./DateTimeSettingIcon.vue";
import CopyIcon from "./CopyIcon.vue";
import Tooltip from "../Tooltip.vue";

const EMIT_EVENTS = {
  AREA_SETTING: "area-setting",
  DATE_TIME_SETTING: "date-time-setting",
  COPY: "copy",
};

export default {
  name: "PlaybackFunctions",
  props: {
    playbackRequestSettings: {
      type: Object, // playbackRequestSettings
      default() {
        return {};
      },
    },
  },
  components: {
    AreaSettingIcon,
    DateTimeSettingIcon,
    CopyIcon,
    Tooltip,
  },
  methods: {
    onClickAreaSetting(event) {
      this.$emit(EMIT_EVENTS.AREA_SETTING, event);
    },
    onClickDateTimeSetting(event) {
      this.$emit(EMIT_EVENTS.DATE_TIME_SETTING, event);
    },
    onClickCopy(event) {
      this.$emit(EMIT_EVENTS.COPY, event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.rg-playback-functions {
  display: flex;
  align-items: center;
  border-radius: 5px;
  .rg-playback-function-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    width: 35px;
    background-color: $aisea-pure-white;

    cursor: pointer;

    &:hover {
      background: #d7effc;
    }

    &:active {
      background: #aee1ff;
    }
    &:first-child {
      border-radius: 5px 0 0 5px;
    }
    &:last-child {
      border-radius: 0 5px 5px 0;
    }
  }
}
</style>
